import { IconSearch } from './Icon';

type Props = {
  valor: string;
  onChange: (v: string) => void;
  placeholder?: string;
  ariaLabel?: string;
};

export function SearchInput({ valor, onChange, placeholder = 'Buscar…', ariaLabel = 'Buscar' }: Props) {
  return (
    <div className="search-input">
      <IconSearch className="search-input__icone" aria-hidden />
      <input
        className="search-input__campo"
        type="search"
        value={valor}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        aria-label={ariaLabel}
      />
    </div>
  );
}

export function normalizarBusca(s: string): string {
  return s.toLowerCase().normalize('NFD').replace(/\p{Diacritic}/gu, '');
}
